import { ConstructionManagementImport } from './Imports'
const { RoutesMap, ConstructionStageList, ConstructionList, ConstructionDetails, AddConstructionDailyLog, EditConstructionDailyLog } = ConstructionManagementImport

const ConstructionManagementRoute = () => {
    return [
        {
            path: RoutesMap.CONSTRUCTION_STAGE_LIST.path,
            element: <ConstructionStageList />
        },

        {
            path: RoutesMap.CONSTRUCTION_LIST.path,
            element: <ConstructionList />
        },

        {
            path: RoutesMap.CONSTRUCTION_DETAILS.path,
            element: <ConstructionDetails />
        },

        {
            path: RoutesMap.ADD_CONSTRUCTION_DAILY_LOG.path,
            element: <AddConstructionDailyLog />
        },

        {
            path: RoutesMap.EDIT_CONSTRUCTION_DAILY_LOG.path,
            element: <EditConstructionDailyLog />
        },
    ]
}

export default ConstructionManagementRoute;
